import React, { useState, useEffect } from 'react'
import { getHistoryBrandRule } from '../../../services/api/apiBrands'
import { message } from 'antd'
import HistoryItem from '../../TagBrandEdit/components/HistoryItem'

function BrandsRuleHistories(props) {
    const { brandRuleId } = props
    const [historyData, setHistoryData] = useState([])
    const [page, _setPage] = useState(1)
    const [limit, _setLimit] = useState(10000)

    const fetchData = async () => {
        const payload = { page: page, limit: limit }
        try {
            const { data: res } = await getHistoryBrandRule(brandRuleId, payload)
            const { success, message: mess, data } = res || {}
            if (!success) {
                throw new Error(mess)
            }
            setHistoryData(data)
        } catch (error) {
            message.error(error.message)
        }
    }

    useEffect(() => {
        if (brandRuleId) fetchData()
    }, [brandRuleId])

    return (Array.isArray(historyData) && historyData.length > 0 &&
        <div className="BrandsRuleHistories SectionInner card mt-3" style={{ fontSize: 15 }}>
            <div className=' p-4 h-100' >
                <h3 className='font-weight-bold'>History</h3>
                {Array.isArray(historyData) && historyData.length > 0 && historyData.map((i, idx) => (
                    <HistoryItem
                        className="BrandsRuleHistoriesItem_"
                        key={`BrandsRuleHistoriesItem__${idx}`}
                        item={i}
                    />
                ))}
            </div>
        </div>
    )
}

export default BrandsRuleHistories